export const currencySymbols = {
  USD: '$',
  EUR: '€',
  '£ - GBP': '£',
  '£': 'GBP ',
  GBP: '£',
  AUD: '$',
};
